/**
 * PanCancer module
 */
import {NgModule} from '@angular/core';

import {CoreModule} from '@ispm/core/core.module';
import {SharedModule} from '@ispm/shared/shared.module';

import {CardModule} from 'primeng/card';
import {DynamicFormModule} from '@ispm/dynamic-form/dynamic-form.module';
import {LayoutEngineModule} from '@ispm-client/modules/layout-engine/layout-engine.module';
import {WidgetsModule} from '@ispm/widgets/widgets.module';
import {AggregatorModule} from '@ispm-client/modules/aggregator/aggregator.module';

import {LayoutModule} from '@ispm/layout/layout.module';


import {ScreeningRecommendationComponent} from './components/recommendation/screening-recommendation.component';
import {ScreeningGuidelineComponent} from './components/guideline/screening-guideline.component';
import {ScreeningService} from './services/screening.service';
import {EligibilityComponent} from '@ispm-client/modules/screening/components/eligibility/eligibility.component';
import {EventsModule} from "@ispm-client/modules/events";
import {PatientModule} from "@ispm-client/modules/patient";
import {SelectionItemModule} from "@ispm-client/modules/selection-item/selection-item.module";
import {ContextProviderModule} from "@ispm-client/modules/context-provider";

@NgModule({
  imports: [
    CoreModule,
    SharedModule,
    CardModule,
    DynamicFormModule,
    LayoutEngineModule,
    WidgetsModule,
    AggregatorModule,
    LayoutModule,
    EventsModule,
    PatientModule,
    SelectionItemModule,
    ContextProviderModule
  ],
  declarations: [ScreeningRecommendationComponent, ScreeningGuidelineComponent, EligibilityComponent],
  providers: [ScreeningService],
  exports: [ScreeningRecommendationComponent, ScreeningGuidelineComponent, EligibilityComponent]
})
export class ScreeningModule {
}
